<template>
  <div class="wt-upload-view">
    <header>
      <span class="wticon wticon-youtube1"
        ><span class="path1" /><span class="path2" /><span class="path3"
      /></span>
      <div class="wt2-text-l3">
        {{ 'uploadView.title.youtube' | culture }}
      </div>
    </header>

    <main>
      <div class="-panel">
        <section>
          <wt-text-field
            class="-url"
            v-model="model.url"
            :placeholder="'uploadView.urlPlaceholder' | culture"
            :mandatory="false"
            :maxlength="MAX_TITLE_LENGTH"
            icon="wticon-link2"
            ref="urlInput"
          />
        </section>
        <section class="-url-error">
          <template v-if="!urlIsValid">{{
            'uploadView.error.url' | culture
          }}</template>
          <template v-else-if="serverError">{{ serverError }}</template>
        </section>
      </div>
      <aside class="-panel-divider" />
      <div class="-panel">
        <section>
          <wt-toggle
            class="-privacy-label"
            :label-left="'uploadView.privacyLabel' | culture"
            v-model="model.sharedWithTeam"
          />
        </section>
        <section>
          <wt-text-field
            v-model="model.attribution"
            :placeholder="'uploadView.attributionPlaceholder' | culture"
            :mandatory="false"
            :maxlength="MAX_TITLE_CREDIT_LENGTH"
          />
          <wt-check-box
            class="-attribution-box wt2-text-s"
            v-model="model.attributionMode"
            :disabled="!model.attribution"
            :label-right="'uploadView.attributionMode' | culture"
          />
        </section>
        <section>
          <wt-add-keywords
            theme="black-theme"
            :keyword-height="31"
            :maxRows="4"
            :keywords="model.keywords"
            emptyKeywordsPlaceholder="Add tags"
            @addkeyword="addKeyword"
            @removekeyword="removeKeyword"
          />
        </section>
      </div>
    </main>

    <footer>
      <wt-button
        :disabled="!urlIsValid || !urlIsSet"
        type="primary"
        text="Upload"
        @click="onDone"
      />
      <wt-button type="transparent" text="Cancel" @click="closeModal" />
    </footer>

    <aside v-show="waiting" class="-waiting">
      <div class="-center">
        {{ 'uploadView.waiting' | culture }}
        <div class="wt-loader" />
      </div>
    </aside>
  </div>
</template>

<script>
import app from 'app';
import UploadMixin from './UploadMixin.vue';
export default {
  mixins: [UploadMixin],

  data() {
    return {
      waiting: false,
      serverError: '',
      model: {
        url: '',
        // url: 'https://www.youtube.com/watch?v=fqOLyKgDpao'
      },
    };
  },

  computed: {
    urlIsSet() {
      return !_.isEmpty(this.model.url);
    },

    urlIsValid() {
      return !this.model.url || app.validate.youtubeUrl(this.model.url);
    },
  },

  mounted() {
    this.$refs.urlInput.focus();
  },

  methods: {
    onDone() {
      this.serverError = '';
      this.waiting = true;

      const postData = Object.assign(this.commonData, {
        url: this.model.url,
      });

      app.api.asset
        .postYoutube(postData)
        .then(
          (asset) => {
            app.namespace.Controller.AssetController.parse(asset);
            // override upload status so we could listen on transcode finish
            asset.metadata.uploadStatus = app.uploadStatus.PROCESSING;
            this.closeModal({ asset });
          },
          (res) => {
            this.serverError = res.error;
          }
        )
        .finally(() => {
          this.waiting = false;
        });
    },
  },
};
</script>
